//router
import LayoutsRoute from './router/layouts-route';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';


//scss files
import './assets/scss/backend.scss';
import  './assets/css/custom.css';
<ToastContainer />
function App() {
  return (
    <div className="App">
      <ToastContainer />
      <LayoutsRoute />
    </div>
  );
}

export default App;
